module.exports = __webpack_public_path__ + "img/violet_032.1aee423f.png";